<script setup lang="ts">
/** Ventilation par statut (mini-badges, statuts à 0 masqués). */
import type { AccompStatus } from '@/v2/accompagnement/api/accompagnementTypes'
import { ACCOMP_STATUS_ORDER, ACCOMP_STATUS_META } from '@/v2/accompagnement/constants/accompagnementConstants'

defineProps<{ byStatus: Record<AccompStatus, number> }>()
</script>

<template>
  <div class="flex flex-wrap gap-1">
    <template v-for="s in ACCOMP_STATUS_ORDER" :key="s">
      <span v-if="byStatus[s]" class="badge badge-sm gap-1" :class="ACCOMP_STATUS_META[s].badgeClass">
        {{ ACCOMP_STATUS_META[s].label }}
        <span class="font-semibold tabular-nums">{{ byStatus[s] }}</span>
      </span>
    </template>
    <span v-if="!ACCOMP_STATUS_ORDER.some((s) => byStatus[s])" class="text-sm text-base-content/70">—</span>
  </div>
</template>
